import repository from '@/utils/repository';

const resource = '/move/MNG_Master008';

export default {
    searchCenterInfo: (data) => {
        return repository.post(`${resource}/searchItem`, {
            ...data
        });
    }
};
